import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "react-oidc-context";

export function Module({ data, isAssociated, onModuleDeleted }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [openUpwards, setOpenUpwards] = useState(false);
  const [menuDirectionUp, setMenuDirectionUp] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [deleting, setDeleting] = useState(false);

  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const auth = useAuth();
  const token = auth.user?.access_token;
  // const API_URL = process.env.REACT_APP_API_URL;
  const API_URL = "/api";

  const handleMenuClick = (e) => {
    e.stopPropagation();

    const buttonRect = e.target.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const menuWidth = 200; // Largeur estimée du menu
    const menuHeight = 150; // Hauteur estimée du menu

    // Vérifie si le menu dépasse en bas de la fenêtre
    const shouldOpenUpwards = buttonRect.bottom + menuHeight > windowHeight;

    // Vérifie si le menu dépasse sur la droite
    let leftPosition = buttonRect.left;
    if (buttonRect.left + menuWidth > windowWidth) {
      leftPosition = buttonRect.right - menuWidth; // Décale le menu vers la gauche
    }

    // Définit la position exacte du menu
    setMenuPosition({
      top: shouldOpenUpwards ? buttonRect.top - menuHeight : buttonRect.bottom,
      left: leftPosition,
    });

    setMenuDirectionUp(shouldOpenUpwards);
    setMenuOpen(true);
  };

  const handleDeleteModule = async (e) => {
    e.stopPropagation();
    setMenuOpen(false);

    // Vérifier que nous avons les données nécessaires
    if (!data.hotel_id || !data.room_id) {
      alert("Erreur : Impossible de supprimer le module, données manquantes");
      return;
    }

    // Demander confirmation
    const confirmDelete = window.confirm(`Êtes-vous sûr de vouloir supprimer définitivement le module ${data.devEUI} ?\n\nCette action est irréversible et supprimera toutes les données associées au module.`);

    if (!confirmDelete) {
      return;
    }

    try {
      setDeleting(true);

      // Appel à l'endpoint DELETE /hotels/:hId/rooms/:id/module
      await axios.delete(`${API_URL}/hotels/${data.hotel_id}/rooms/${data.room_id}/module`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Succès : notifier le parent et recharger les données
      alert("Module supprimé avec succès !");

      // Appeler le callback pour recharger les données
      if (onModuleDeleted) {
        onModuleDeleted(data.id);
      }
    } catch (error) {
      console.error("Erreur lors de la suppression du module:", error);

      // Afficher un message d'erreur plus détaillé
      const errorMessage = error.response?.data?.error || error.response?.data?.message || "Erreur lors de la suppression du module";
      alert(`Erreur : ${errorMessage}`);
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    if (menuOpen && menuRef.current && buttonRef.current) {
      const menuRect = menuRef.current.getBoundingClientRect();
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const overflowBottom = menuRect.bottom > window.innerHeight;
      const overflowTop = buttonRect.top > menuRect.height;
      setOpenUpwards(overflowBottom && overflowTop);
    }
  }, [menuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <tr className="cursor-pointer hover:bg-gray-50 relative">
      <td className="px-6 py-4 whitespace-nowrap">{data.id}</td>
      <td className="px-6 py-4 whitespace-nowrap">{data.devEUI}</td>
      <td className="px-6 py-4 whitespace-nowrap">{data.version}</td>
      <td className="px-6 py-4 whitespace-nowrap text-right relative">
        <button ref={buttonRef} onClick={handleMenuClick} className="text-gray-500 hover:text-gray-700" disabled={deleting}>
          {deleting ? "..." : "•••"}
        </button>
        {menuOpen && (
          <div
            ref={menuRef}
            style={{
              position: "fixed",
              top: `${menuPosition.top}px`,
              left: `${menuPosition.left}px`,
              zIndex: 1000,
            }}
            className="w-48 bg-white border border-gray-200 rounded-md shadow-lg"
          >
            <ul>
              <li onClick={handleDeleteModule} className="px-4 py-2 hover:bg-red-50 cursor-pointer text-red-600 font-medium transition-colors duration-150" disabled={deleting}>
                {deleting ? "Suppression..." : "Supprimer module"}
              </li>
            </ul>
          </div>
        )}
      </td>
    </tr>
  );
}
